import React, { useEffect } from 'react';
import { CountdownProvider } from './contexts/CountdownContext';
import { PromoBar } from './components/PromoBar';
import { Hero } from './components/Hero';
import { Pains } from './components/Pains';
import { MainProduct } from './components/MainProduct';
import { Bonuses } from './components/Bonuses';
import { FormatNotice } from './components/FormatNotice';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { OfferCard } from './components/OfferCard';
import { Guarantee } from './components/Guarantee';
import { Buyers } from './components/Buyers';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { MobileStickyCta } from './components/MobileStickyCta';
import { PurchaseToast } from './components/PurchaseToast';
import { offer } from './data/offer';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel(offer.metaPixelId);
    trackPixelEvent('ViewContent', {
      value: offer.priceValue,
      currency: offer.currency,
      content_name: offer.productName
    });
  }, []);
  return <CountdownProvider endISO={offer.promoEnd} data-id="element-0" data-mp="3recc1ebn6dd1">
      <div className="min-h-screen w-full bg-[#120D0A]" data-id="element-1" data-mp="682rygdekbl">
        <div className="mx-auto min-h-screen w-full max-w-[480px] bg-espresso pb-24 font-sans shadow-frame" data-id="element-2" data-mp="7sxbo2oq39g">
          <PromoBar data-id="element-3" data-mp="33moqzd129wio" />
          <main data-id="element-4" data-mp="33lwyib2rgewm">
            <Hero data-id="element-5" data-mp="33ngf62sbwryx" />
            <Pains data-id="element-6" data-mp="33mymth8sexwa" />
            <MainProduct data-id="element-7" data-mp="33oi1j3esp0vy" />
            <Bonuses data-id="element-8" data-mp="38l8iru2c62iy" />
            <FormatNotice data-id="element-9" data-mp="38kqafz2efxuo" />
            <HowItWorks data-id="element-10" data-mp="38kgmeh0x00rm" />
            <Testimonials data-id="element-11" data-mp="3dkuufz2inapn" />
            <OfferCard data-id="element-12" data-mp="3dl4n5uey3vz1" />
            <Guarantee data-id="element-13" data-mp="3dlnt0crbmtwp" />
            <Buyers data-id="element-14" data-mp="3dirtwl3qlz6o" />
            <Faq data-id="element-15" data-mp="nvj3jfxq0epq" />
            <FinalCta data-id="element-16" data-mp="nw2bq4xkjoqk" />
          </main>
          <Footer data-id="element-17" data-mp="nv0x5qhcgk43" />
        </div>
        <MobileStickyCta data-id="element-18" data-mp="sunby4ctm8f0" />
        <PurchaseToast data-id="element-19" data-mp="su427axbqqc2" />
      </div>
    </CountdownProvider>;
}